import React, { useEffect, useState} from "react";
import Header from "../components/Header";
import cgrIcon from "../images/cgrIcon.svg";
import Product4 from "../components/Product4";
import Modal from 'react-bootstrap/Modal';
import { Link , useLocation ,useParams } from "react-router-dom";
import pointIllust from "../images/pointillust.svg";
import { useTranslation } from 'react-i18next';
import { useAxios } from "../services/useAxios";
import {alert, confirm} from "../components/MegConfirmAlert";

export default function ConfirmGoodsReceived () {
    const { t } = useTranslation();
    const [modalShow, setModalShow] = React.useState(false);
    const [data, setData] = useState({});
    const [mileageInfo, setMileageInfo] = useState({});
    const [checkItems, setCheckItems] = useState([]);
    let {id} = useParams();
    const [request] = useAxios();

    const handleSingleCheck = (checked, obj) => {
        if (checked) {
          // 단일 선택 시 체크된 아이템을 배열에 추가
          setCheckItems(prev => [...prev, obj]);
        } else {
          // 단일 선택 해제 시 체크된 아이템을 제외한 배열 (필터)
          setCheckItems(checkItems.filter((el) => el.orderDetailSn !== obj.orderDetailSn));
        }
      };

      const handleAllCheck = (checked) => {
        if(checked) {
          // 전체 선택 클릭 시 데이터의 모든 아이템(id)를 담은 배열로 checkItems 상태 업데이트
          const idArray = [];
          data.orderDetailList.forEach((el) => idArray.push(el));
          setCheckItems(idArray);
        }
        else {
          // 전체 선택 해제 시 checkItems 를 빈 배열로 상태 업데이트
          setCheckItems([]);
        }
      }


    const fetchData = async () => {
       
        const response = await request.post("/app/mypage/getMyOrderConfirmTargetInfoAPI", {
            orderNo: id
        });

        if(response.data.resultCode === 200){

            if(!response.data.result.orderDetailList || response.data.result.orderDetailList.length === 0){
                await alert(t(`Message.confirm_goods_received_no_product`));
                window.location.href="/OrderHistory";
            }
                 
            setData(response.data.result);          
                  
        }
    };

    const fn_confirm = async () => {
        if(checkItems.length === 0){
            alert(t(`Message.my_order_confirm_select_goods`));
            return;
        }
        const response = await request.post("/app/mypage/procMyOrderConfirmAPI", checkItems);
        if(response.data.resultCode === 200){            
            setMileageInfo(response.data.result)
            setModalShow(true)
        }else{
            alert(response.data.resultMessage);
        }
    }

    useEffect(() => {
        fetchData();        
      }, []);
    return (
        <div>
            <div className="backGround bgBlue"></div>
            <Header type="cart" pageTitle={t(`Message.my_order_confirm_title`)}/>


            <div className="dfColG12 cgrWr">
                <div className="cgrNotice">
                    <img src={cgrIcon} alt={t(`Message.my_order_confirm_title`)}/>
                    <div className="dfColG8 w80per">
                        <p className="fs17 fw700 cFFF txtR">{t(`Message.my_order_confirm_ggods_list_msg`)}</p>
                        <p className="fs14 cFFF txtR">{t(`Message.my_order_confirm_ggods_list_sub_msg1`)} {t(`Message.my_order_confirm_ggods_list_sub_msg2`)}</p>
                    </div>
                </div>

                <div className="chkWr cgrAll">
                    <input type="checkbox" id="aa" onChange={(e) => handleAllCheck(e.target.checked)}
                            checked={checkItems.length === (data.orderDetailList?data.orderDetailList.length:0) ? true : false}/>
                    <label htmlFor="aa">{t(`Message.all_check_overall_selection`)}</label>
                </div>
                {data.orderDetailList && data.orderDetailList.map((obj, index) => (
                <Product4 key={index}
                    type="type11"
                    img={"https://www.salee.co.kr/com/cmm/getGoodsImageView.sale?goodsFileTy=i&goodsFileSn="+obj.goodsImageSn}
                    prodName={obj.goodsNm}
                    option1={obj.firstOptnNm+ " "+ obj.firstOptnValue + " X "+  obj.orderQy}
                    mileage1={obj.buyMlgAmount}
                    mileage2={obj.reviewMlgAmount}
                    obj ={obj}
                    checkItems = {checkItems}
                    handleSingleCheck = {handleSingleCheck}
                />
                 ))}                     
            </div>


            <button type="button" className="floatBtn" onClick={() => fn_confirm()}>{t(`Message.my_order_confirm_title`)}</button>




            <Modal 
                className="btModal"
                show={modalShow}
                onHide={() => setModalShow(false)}
                size="sm"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                >
                
                <div className="cgrModal">
                    <img src={pointIllust} alt={t(`Message.my_order_confirm_goods_confirm_mlg`)} />
                    <div className="cgrMent">
                        <p className="cBlue">{(!mileageInfo.mlgAccmlAmount?0:mileageInfo.mlgAccmlAmount).toLocaleString('ko-KR')} {t(`Message.my_order_confirm_goods_confirm_mlg`)}</p>
                        <p className="cBlack">{t(`Message.my_order_confirm_result_dialog_accumulated_msg`)}</p>
                    </div>
                    <div className="mmStatus">
                        <p>{t(`Message.my_order_confirm_result_dialog_my_mlg`)}</p>
                        <p className="fw600">{(!mileageInfo.totalMlgAmount?0:mileageInfo.totalMlgAmount).toLocaleString('ko-KR')}</p>
                    </div>
                </div>
                <div className="cgrModalBtnWr">
                    <Link to="/Review" className="btn40 orgB cFFF">{t(`Message.my_order_confirm_result_dialog_review_add_mlg`)}</Link>
                    <button onClick={() => window.location.href="/OrderHistory"} className="cDisa">{t(`Message.my_order_confirm_result_dialog_next_time`)}</button>
                </div>
            </Modal>

        </div>
    );
};